import Auth from "@/app/auth/core/router-const"
import { CRM_PERMS } from "@/util/const"

export default Object.freeze({
  RESERVATION: 'reservation',
  RESERVATION_ITEM: 'reservation-item',
  RESERVATION_ADD: 'reservation-add',
  CANDIDATES: CRM_PERMS.CANDIDATES,
  CANDIDATES_ALL: 'candidate_all',
  CANDIDATES_ITEM: 'candidates_item',
  CANDIDATES_TASKS: 'CANDIDATES',
  CANDIDATES_WAIT: 'candidate_wait',
  CANDIDATES_RESERVE_EXCHANGE: 'candidate_reserve_exchange',
  CANDIDATES_RESERVED_EXCHANGED: 'candidate_reserved_exchanged',
  CANDIDATES_PROCESSED: 'candidate_processed',
  RESULTS: CRM_PERMS.RESULTS,
  SLOTS: CRM_PERMS.SLOTS,
  RESERVED: CRM_PERMS.RESERVED_EXAMS,
  CBR_ACC: CRM_PERMS.CBR_ACCOUNTS,
  CBR_ACC_AVALIABLE: 'cbr_acc_avaliable',
  COURSE_MANAGMENT: CRM_PERMS.COURSE_MANAGMENT,
  COURSE_MANAGMENT_ALL: 'course_management_all',
  CURSSUSEN: 'curssusen',
  COURSE_LEADERS: 'course-leaders',
  DRIVING_SCHOOLS: CRM_PERMS.DRIVING_SCHOOLS,
  ...Auth,
})
